$(function() {
    $(document).on('click', 'a[data-logout-form]', function(event) {
        event.preventDefault();
        let formId = $(this).data('logout-form');
        let form = $('#' + formId);
        if (form.length) {
            form.trigger('submit');
        } else {
            window.location.href = this.href;
        }
    });

    $(document).on('click', '.js-documentation-close', function() {
        window.close();
    });

    datepicker();
});
